/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum AddressType {
  PHYSICAL = 'physical',
  MAILING = 'mailing',
  VEHICLE = 'vehicle',
  RECORD_STORAGE = 'record_storage',
  VIRTUAL_OFFICE = 'virtual_office',
  TEXAS_AGENT = 'texas_agent',
}
